import React from 'react';
import ArticleCard from './ArticleCard';

const ArticleGrid = ({ articles, title  }) => {
  if (!articles || articles.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-500">Aucun article trouvé</p>
      </div>
    );
  }

  return (
    <section className="py-8 -mt-16">
      <h2 className="text-2xl font-bold text-gray-800 mb-6">{title}</h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {articles.map((article, index) => (
          <ArticleCard 
            key={article.id} 
            article={article} 
            size={index === 0 ? 'large' : 'default'} 
          />
        ))}
      </div>
    </section>
  );
};

export default ArticleGrid;